module.exports = __webpack_public_path__ + "static/media/SsangYong-logo-640x422.f796e202.jpg";